/**
 * Translate the Checkout+ widget copy into the selected
 * languages based on the url prefixes:
 *   unprefixed French pages -> French
 *   /fr-ca, /fr-ch, /fr-roe -> French
 *   /de-de, /de-ch, /de-roe -> German
 *   /ja-jp         -> Japanese
 */
(function translateCheckoutPlus() {
  const LOCALE_PATTERNS = [
    { lang: 'de-de', pattern: /^\/de-de(\/|$)/ },
    { lang: 'de-ch', pattern: /^\/de-ch(\/|$)/ },
    { lang: 'de-roe', pattern: /^\/de-roe(\/|$)/ },
    { lang: 'ja', pattern: /^\/ja-jp(\/|$)/ },
    { lang: 'fr-ca', pattern: /^\/fr-ca(\/|$)/ },
    { lang: 'fr-ch', pattern: /^\/fr-ch(\/|$)/ },
    { lang: 'fr-roe', pattern: /^\/fr-roe(\/|$)/ },
    { lang: 'fr', pattern: /^\/fr(\/|$)/ },
  ];

  function detectLang(pathname) {
    const matched = LOCALE_PATTERNS.find(({ pattern }) => pattern.test(pathname));
    if (matched) return matched.lang;

    // The French default market has no URL prefix on any page, not just /.
    return document.documentElement.lang.toLowerCase().startsWith('fr') ? 'fr' : null;
  }

  // We only ever translate inside the cart widget (<checkout-plus>) and its info modal
  // (<protection-modal>)
  const WIDGET_HOST_SELECTOR = 'checkout-plus, protection-modal';

  const TRANSLATIONS_BY_LANG = {
    'fr': [
      { selector: ".product-title", text: "Finaliser ma commande" },
      { selector: ".product-caption", text: "Profiter des retours gratuits" },
      { selector: "#primary-button", text: "Finaliser ma commande avec retours gratuits" },
      { selector: "#secondary-button", text: "Finaliser ma commande sans retours gratuits" },
      { selector: "h5", text: "Profiter des retours gratuits pour 3,96 €" },
      { selector: ".protection-content p:nth-of-type(1) span", text: "En réglant dès maintenant 3,96 € lors de votre commande, vous bénéficierez d'un retour sans frais supplémentaires, ce qui vous permettra d'optimiser votre retour en évitant des frais de traitement et d'expédition plus élevés." },
      { selector: ".protection-content p:nth-of-type(2) span", text: "Si vous ne choisissez pas de régler les frais de 3,96 € dès maintenant, vous pourrez tout de même effectuer un retour, mais les frais de traitement seront à votre charge." },
      { selector: ".protection-content p:nth-of-type(3) span i", text: "Les conditions générales du magasin peuvent exclure certains articles de ce service, notamment ceux faisant l'objet d'une vente définitive." }
    ],
    'fr-ca': [
      { selector: ".product-title", text: "Finaliser ma commande" },
      { selector: ".product-caption", text: "Profiter des retours gratuits" },
      { selector: "#primary-button", text: "Finaliser ma commande avec retours gratuits" },
      { selector: "#secondary-button", text: "Finaliser ma commande sans retours gratuits" },
      { selector: "h5", text: "Profiter des retours gratuits pour 3,96 €" },
      { selector: ".protection-content p:nth-of-type(1) span", text: "En réglant dès maintenant 3,96 € lors de votre commande, vous bénéficierez d'un retour sans frais supplémentaires, ce qui vous permettra d'optimiser votre retour en évitant des frais de traitement et d'expédition plus élevés." },
      { selector: ".protection-content p:nth-of-type(2) span", text: "Si vous ne choisissez pas de régler les frais de 3,96 € dès maintenant, vous pourrez tout de même effectuer un retour, mais les frais de traitement seront à votre charge." },
      { selector: ".protection-content p:nth-of-type(3) span i", text: "Les conditions générales du magasin peuvent exclure certains articles de ce service, notamment ceux faisant l'objet d'une vente définitive." }
    ],
    'fr-ch': [
      { selector: ".product-title", text: "Finaliser ma commande" },
      { selector: ".product-caption", text: "Profiter des retours gratuits" },
      { selector: "#primary-button", text: "Finaliser ma commande avec retours gratuits" },
      { selector: "#secondary-button", text: "Finaliser ma commande sans retours gratuits" },
      { selector: "h5", text: "Profiter des retours gratuits pour 3,96 €" },
      { selector: ".protection-content p:nth-of-type(1) span", text: "En réglant dès maintenant 3,96 € lors de votre commande, vous bénéficierez d'un retour sans frais supplémentaires, ce qui vous permettra d'optimiser votre retour en évitant des frais de traitement et d'expédition plus élevés." },
      { selector: ".protection-content p:nth-of-type(2) span", text: "Si vous ne choisissez pas de régler les frais de 3,96 € dès maintenant, vous pourrez tout de même effectuer un retour, mais les frais de traitement seront à votre charge." },
      { selector: ".protection-content p:nth-of-type(3) span i", text: "Les conditions générales du magasin peuvent exclure certains articles de ce service, notamment ceux faisant l'objet d'une vente définitive." }
    ],
    'fr-roe': [
      { selector: ".product-title", text: "Finaliser ma commande" },
      { selector: ".product-caption", text: "Profiter des retours gratuits" },
      { selector: "#primary-button", text: "Finaliser ma commande avec retours gratuits" },
      { selector: "#secondary-button", text: "Finaliser ma commande sans retours gratuits" },
      { selector: "h5", text: "Profiter des retours gratuits pour 5,96 €" },
      { selector: ".protection-content p:nth-of-type(1) span", text: "En réglant dès maintenant 5,96 € lors de votre commande, vous bénéficierez d'un retour sans frais supplémentaires, ce qui vous permettra d'optimiser votre retour en évitant des frais de traitement et d'expédition plus élevés." },
      { selector: ".protection-content p:nth-of-type(2) span", text: "Si vous ne choisissez pas de régler les frais de 5,96 € dès maintenant, vous pourrez tout de même effectuer un retour, mais les frais de traitement seront à votre charge." },
      { selector: ".protection-content p:nth-of-type(3) span i", text: "Les conditions générales du magasin peuvent exclure certains articles de ce service, notamment ceux faisant l'objet d'une vente définitive." }
    ],
    'de-de': [
      { selector: ".product-caption", text: "Sichern Sie sich unseren Retour-Service ohne Zusatzkosten" },
      { selector: "#primary-button", text: "CHECKOUT+ mit Retour-Service" },
      { selector: "#secondary-button", text: "CHECKOUT ohne Retour-Service" },
      { selector: "h5", text: "Schalten Sie kostenlose Retouren für 5,96 € frei" },
      { selector: ".protection-content p:nth-of-type(1) span", text: "Wenn Sie jetzt 5,96 € für Ihre Bestellung bezahlen, können Sie kostenlos zurücksenden und so höhere Bearbeitungs- und Versandkosten bei einer Rücksendung vermeiden." },
      { selector: ".protection-content p:nth-of-type(2) span", text: "Wenn Sie sich entscheiden, die Gebühr von 5,96 € jetzt nicht zu zahlen, können Sie dennoch eine Rücksendung vornehmen, tragen dabei aber die Bearbeitungsgebühr selbst." },
      { selector: ".protection-content p:nth-of-type(3) span i", text: "Die Rückgaberichtlinien des Shops können bestimmte Artikel von diesem Service ausschließen, etwa vom Umtausch ausgeschlossene Sale-Artikel." }
    ],
    'de-ch': [
      { selector: ".product-caption", text: "Sichern Sie sich unseren Retour-Service ohne Zusatzkosten" },
      { selector: "#primary-button", text: "CHECKOUT+ mit Retour-Service" },
      { selector: "#secondary-button", text: "CHECKOUT ohne Retour-Service" },
      { selector: "h5", text: "Schalten Sie kostenlose Retouren für 5,96 € frei" },
      { selector: ".protection-content p:nth-of-type(1) span", text: "Wenn Sie jetzt 5,96 € für Ihre Bestellung bezahlen, können Sie kostenlos zurücksenden und so höhere Bearbeitungs- und Versandkosten bei einer Rücksendung vermeiden." },
      { selector: ".protection-content p:nth-of-type(2) span", text: "Wenn Sie sich entscheiden, die Gebühr von 5,96 € jetzt nicht zu zahlen, können Sie dennoch eine Rücksendung vornehmen, tragen dabei aber die Bearbeitungsgebühr selbst." },
      { selector: ".protection-content p:nth-of-type(3) span i", text: "Die Rückgaberichtlinien des Shops können bestimmte Artikel von diesem Service ausschließen, etwa vom Umtausch ausgeschlossene Sale-Artikel." }
    ],
    'de-roe': [
      { selector: ".product-caption", text: "Sichern Sie sich unseren Retour-Service ohne Zusatzkosten" },
      { selector: "#primary-button", text: "CHECKOUT+ mit Retour-Service" },
      { selector: "#secondary-button", text: "CHECKOUT ohne Retour-Service" },
      { selector: "h5", text: "Schalten Sie kostenlose Retouren für 5,96 € frei" },
      { selector: ".protection-content p:nth-of-type(1) span", text: "Wenn Sie jetzt 5,96 € für Ihre Bestellung bezahlen, können Sie kostenlos zurücksenden und so höhere Bearbeitungs- und Versandkosten bei einer Rücksendung vermeiden." },
      { selector: ".protection-content p:nth-of-type(2) span", text: "Wenn Sie sich entscheiden, die Gebühr von 5,96 € jetzt nicht zu zahlen, können Sie dennoch eine Rücksendung vornehmen, tragen dabei aber die Bearbeitungsgebühr selbst." },
      { selector: ".protection-content p:nth-of-type(3) span i", text: "Die Rückgaberichtlinien des Shops können bestimmte Artikel von diesem Service ausschließen, etwa vom Umtausch ausgeschlossene Sale-Artikel." }
    ],
    'ja': [
      { selector: ".product-title", text: "チェックアウト+" },
      { selector: ".product-caption", text: "無料返品を利用する" },
      { selector: "#primary-button", text: "チェックアウト+（無料返品対応）" },
      { selector: "#secondary-button", text: "無料返品なしでチェックアウト" },
      { selector: "h5", text: "3.96€で無料返品を有効にする" },
      { selector: ".protection-content p:nth-of-type(1) span", text: "ご注文時に3.96€をお支払いいただくと、追加料金なしで返品が可能になり、返品時の手数料や送料の負担を抑えることができます。" },
      { selector: ".protection-content p:nth-of-type(2) span", text: "3.96€のお支払いを選択されない場合でも返品は可能ですが、その際の手数料はお客様のご負担となります。" },
      { selector: ".protection-content p:nth-of-type(3) span i", text: "最終セール品など、一部の商品は当店のポリシーによりこのサービスの対象外となる場合があります。" }
    ]
  };

  const TRANSLATION_RULES = TRANSLATIONS_BY_LANG[detectLang(location.pathname)] || null;

  const observedShadowRoots = new WeakSet();

  function displayedFee(root) {
    const heading = root.querySelector('h5');
    const price = heading?.textContent.match(/(?:€|£|\$|¥|CHF|EUR|USD|CAD|JPY)\s?[\d.,]+|[\d.,]+\s?(?:€|£|\$|¥|CHF|EUR|USD|CAD|JPY)/);
    return price?.[0] || null;
  }

  function applyRulesToElement(element, fee) {
    if (!TRANSLATION_RULES) return;

    TRANSLATION_RULES.forEach((rule) => {
      if (!element.matches(rule.selector)) return;

      const hasPrice = /(?:3,96 €|5,96 €|3\.96€)/.test(rule.text);
      if (hasPrice && !fee) return;
      const text = hasPrice ? rule.text.replace(/(?:3,96 €|5,96 €|3\.96€)/g, fee) : rule.text;
      if (element.textContent !== text) {
        element.textContent = text;
      }
    });
  }

  function watch(target, options, onChange) {
    new MutationObserver(onChange).observe(target, options);
  }

  function applyTranslations(root) {
    try {
      const fee = displayedFee(root);
      root.querySelectorAll('*').forEach((element) => {
        applyRulesToElement(element, fee);

        const shadowRoot = element.shadowRoot;
        if (!shadowRoot) return;

        if (!observedShadowRoots.has(shadowRoot)) {
          observedShadowRoots.add(shadowRoot);
          watch(
            shadowRoot,
            { childList: true, subtree: true, characterData: true },
            () => applyTranslations(shadowRoot)
          );
        }

        applyTranslations(shadowRoot);
      });
    } catch (error) {
      console.warn('checkout-plus failed to translate widget', error);
    }
  }

  // Translate every known widget host currently on the page.
  function translateAllWidgets() {
    document.querySelectorAll(WIDGET_HOST_SELECTOR).forEach((host) => {
      const shadowRoot = host.shadowRoot;
      if (!shadowRoot) return;

      if (!observedShadowRoots.has(shadowRoot)) {
        observedShadowRoots.add(shadowRoot);
        watch(
          shadowRoot,
          { childList: true, subtree: true, characterData: true },
          () => applyTranslations(shadowRoot)
        );
      }

      applyTranslations(shadowRoot);
    });
  }

  translateAllWidgets();

  // Catch checkout-plus / protection-modal mounting or re-mounting
  // anywhere in the document (protection-modal in particular isn't
  // created until the shopper first opens the info modal).
  watch(
    document.documentElement,
    { childList: true, subtree: true },
    translateAllWidgets
  );
})();
